import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import User from './user';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_CLIENT_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_WEB_APP_ID,
  measurementId: 'G-NXZ5YR54QR',
};

export const initFirebase = () => {
  if (!getApps().length) {
    const app = initializeApp(config);
    const analytics = getAnalytics(app);
  }
};

class FirebaseApi {
  user: User;
  constructor() {
    this.user = new User();
  }
}

export const firebaseApi = new FirebaseApi();
